
import React from 'react';
import BusRatesTable from './BusRatesTable';
import RisingCabPayment from './RisingCabPayment ';


const Packages = () => {
  return (
   <div>

  <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.3)",
            zIndex: 1, }}></div>

        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Packages</h1>
          </div>
        </div>
      </div>

       



    {/* <CabRatesTable/> */}
<BusRatesTable/>

<RisingCabPayment/>
<div
  className="rules-guidelines container my-5"
  style={{
    maxWidth: "1000px",
  }}
>
  <div
    style={{
      background: "#fff",
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 10px 35px rgba(0,0,0,0.08)",
      border: "1px solid #e8e8e8",
    }}
  >
    {/* Header */}
    <div
      style={{
        background:
          "linear-gradient(135deg, #1E355E 0%, #294A82 50%, #F47C20 100%)",
        padding: "25px",
        textAlign: "center",
      }}
    >
      <h2
        style={{
          color: "#fff",
          margin: 0,
          fontWeight: "700",
          letterSpacing: "0.5px",
        }}
      >
        <i className="fas fa-clipboard-list me-2"></i>
        Rules & Guidelines
      </h2>

      <p
        style={{
          color: "#f5f5f5",
          marginTop: "8px",
          marginBottom: 0,
        }}
      >
        Please read the following terms before booking.
      </p>
    </div>

    {/* Body */}
    <div
      style={{
        padding: "35px",
        background: "#fff",
      }}
    >
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
        }}
      >
        {[
          "Driver Allowance will charge extra.",
          "Cab running km is limited to 300 km per day.",
          // "Time starts from 6:00 AM to 10:00 PM and the cab must be free at 10:00 PM. After 10:00 PM extra charges apply. Night charges apply from 12:00 AM to 6:00 AM.",
          "Time and km will be calculated from our office to office.",
          "Interstate taxes, toll taxes, parking and service tax are charged as actuals.",
          "Extra charges will apply for extra km and hours. Government taxes will be charged as per government rules.",
          "The charges quoted above are calculated based on current fuel prices. Any hike in fuel prices may result in a variation in rates.",
        ].map((item, index) => (
          <li
            key={index}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "15px",
              padding: "16px 0",
              borderBottom:
                index !== 6 ? "1px solid #f0f0f0" : "none",
            }}
          >
            <div
              style={{
                minWidth: "35px",
                height: "35px",
                borderRadius: "50%",
                background: "#F47C20",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              {index + 1}
            </div>

            <span
              style={{
                color: "#333",
                fontSize: "16px",
                lineHeight: "28px",
              }}
            >
              {item}
            </span>
          </li>
        ))}
      </ul>
    </div>

    {/* Footer */}
    <div
      style={{
        background: "#f8f9fb",
        padding: "18px",
        textAlign: "center",
        borderTop: "1px solid #eee",
      }}
    >
      <span
        style={{
          color: "#1E355E",
          fontWeight: "600",
        }}
      >
        🚖 Risinng Cab – Safe, Reliable & Affordable Travel
      </span>
    </div>
  </div>
</div>

   </div>
  );
};

export default Packages;
